/**
 * åç«¯æ¨¡åç±»åæä¸¾ï¼å¯æå±ï¼
 */
export enum TenantUsableModuleType {
  ONLINE_COURSE = 'ONLINE_COURSE',
  OFFLINE_TRAIN = 'OFFLINE_TRAIN',
  ONLINE_EXAM = 'ONLINE_EXAM',
  OFFLINE_EXAM = 'OFFLINE_EXAM',
  SURVEY = 'SURVEY',
  PRACTICE = 'PRACTICE',
  TRAIN_PLAN = 'TRAIN_PLAN',
  ARCHIVE = 'ARCHIVE',
  ASSESSMENT = 'ASSESSMENT',
  TRNEE = 'TRNEE',
  NEW_NURSE = 'NEW_NURSE',
  BASE_ARCHIVE = 'BASE_ARCHIVE',
  SIMULATION_EXAM = 'SIMULATION_EXAM',
  STUDY_CLASS = 'STUDY_CLASS',
  QUALITY_CONTROL = 'QUALITY_CONTROL',
  ONLINE_TASK = 'ONLINE_TASK',
  PRACTICAL_TRAIN = 'PRACTICAL_TRAIN',
  ONLINE_NOTICE = 'ONLINE_NOTICE',
  NEW_PRACTICE = 'NEW_PRACTICE'
}


const TenantUsableModuleTypeTextMap = new Map<TenantUsableModuleType, string>([
  [TenantUsableModuleType.ONLINE_COURSE, 'å¹è®­è¯¾ç¨'],
  [TenantUsableModuleType.OFFLINE_TRAIN, 'çº¿ä¸ç­¾å°'],
  [TenantUsableModuleType.ONLINE_EXAM, 'çè®ºèè¯'],
  [TenantUsableModuleType.OFFLINE_EXAM, 'æä½èè¯'],
  [TenantUsableModuleType.SURVEY, 'é®å·'],
  [TenantUsableModuleType.PRACTICE, 'èªæµç»ä¹ '],
  [TenantUsableModuleType.TRAIN_PLAN, 'å¹è®­è®¡å'],
  [TenantUsableModuleType.ARCHIVE, 'æè½æ¡£æ¡'],
  [TenantUsableModuleType.ASSESSMENT, 'èæ ¸æ å'],
  [TenantUsableModuleType.TRNEE, 'å®ä¹ çè½®è½¬'],
  [TenantUsableModuleType.NEW_NURSE, 'è§å¹æ¤å£«è½®è½¬'],
  [TenantUsableModuleType.BASE_ARCHIVE, 'åºç¡æè½æ¡£æ¡'],
  [TenantUsableModuleType.SIMULATION_EXAM, 'æ¨¡æè'],
  [TenantUsableModuleType.STUDY_CLASS, 'å­¦ä¹ ç­'],
  [TenantUsableModuleType.QUALITY_CONTROL, 'å¸®è´¨æ§'],
  [TenantUsableModuleType.ONLINE_TASK, 'ä½ä¸'],
  [TenantUsableModuleType.PRACTICAL_TRAIN, 'å®è®­'],
  [TenantUsableModuleType.ONLINE_NOTICE, 'éç¥'],
  [TenantUsableModuleType.NEW_PRACTICE, 'æ¤ççè']
]);

export { TenantUsableModuleTypeTextMap };
